import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import * as services from "./services";

export function* GET_CURRENT_USER({ payload }) {
  const { uid, history = null } = payload;
  const response = yield call(services.getCurrentUser, uid);
  if (response.exists && !response.disabled) {
    if(response.activationDate <= new Date().getTime() && !response.isActive) {
      yield put({
        type: actions.DISABLE_USER, 
        payload: {
          data:{
          newUser: { ...response },
          authenticated: true,
          globalLoading: false,
          loginError: false,
          showRenewMessage: true,
          loading: false
        }}
      })
    }else{
      localStorage.setItem("currentUser", JSON.stringify(response))
      yield put({
        type: actions.SET_STATE,
        payload: {
          currentUser: { ...response },
          authenticated: true,
          globalLoading: false,
          loginError: false,
          showRenewMessage: false
        },
      });
    }
    
  } else if(response.exists && response.disabled && history){
    yield put({
      type: actions.SET_STATE,
      payload: {
        newUser: { ...response },
        authenticated: true,
        globalLoading: false,
        loginError: false,
        showRenewMessage: true,
        loading: false
      },
    });
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        currentUser: {},
        authenticated: false,
        globalLoading: false,
        showRenewMessage: false
      },
    });
  }
}

export function* AUTH_USER({ payload }) {
  const { email, password } = payload;
  yield put({
    type: actions.SET_STATE,
    payload: { loginError: false, loading: true },
  });
  const response = yield call(services.authUser, email, password);
  if (response.success) {
    yield put({
      type: actions.GET_CURRENT_USER,
      payload: { loginError: false, loading: false, history: payload.history, uid: email },
    });
    
  }else {
    yield put({
      type: actions.SET_STATE,
      payload: { loginError: response.message, loading: false },
    });
  }
}

export function* RESET_PASSWORD({payload}) {
  const {email} = payload
  const response = yield call(services.resetPassword, email);
  if (response === true) {
    yield put({
      type: actions.SET_STATE,
      payload: { resetSuccess: true, resetError: false },
    });
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: { resetSuccess: false, resetError: response },
    });
  }
}

export function* GET_PLANS() {
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  const response = yield call(services.getPlans);
  yield put({
    type: actions.SET_STATE,
    payload: { plans: response, loading: false },
  });
}

export function* DISABLE_USER({payload}) {
  const {data} = payload
  yield call(services.disableUser, data.newUser.email);
  yield put({
    type: actions.SET_STATE,
    payload:{
      ...data,
      newUser: {...data.newUser, disabled: true},
    }
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_CURRENT_USER, GET_CURRENT_USER),
    takeEvery(actions.AUTH_USER, AUTH_USER),
    takeEvery(actions.RESET_PASSWORD, RESET_PASSWORD),
    takeEvery(actions.GET_PLANS, GET_PLANS),
    takeEvery(actions.DISABLE_USER, DISABLE_USER),
  ]);
}
